// @flow

import { useEffect, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isNil, prop } from 'ramda'

import { changeGuestAccessTTL } from '@alphaott/app-core/actions'
import { getGuestAccessTrialExpires, shouldOpenTrialExpiredScreen } from '@alphaott/app-core/selectors'
import { getGuestAccessTrialConfig } from '@alphaott/app-main/selectors'

import { useGuestAccessTimer } from './useGuestAccessTimer'

export type UseGuestAccessProps = {
  onExpire: () => void,
}

export const useGuestAccess = ({ onExpire }: UseGuestAccessProps) => {
  const dispatch = useDispatch()
  useGuestAccessTimer()

  const isShouldOpenTrialExpiredScreen = useSelector(shouldOpenTrialExpiredScreen)
  const trialConfig = useSelector(getGuestAccessTrialConfig)
  const trialExpires = useSelector(getGuestAccessTrialExpires)

  const initialTrialExpires = useMemo(() => prop('expires', trialConfig), [trialConfig])

  const handleChangeTTL = useCallback((expires: number) => dispatch(changeGuestAccessTTL({ expires })), [dispatch])

  // Save guest access TTL
  useEffect(() => {
    if (isNil(trialExpires)) {
      handleChangeTTL(initialTrialExpires)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // Navigate customer to expired-trial page if trial period has expired
  useEffect(() => {
    if (isShouldOpenTrialExpiredScreen) {
      onExpire()
    }
  }, [isShouldOpenTrialExpiredScreen]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useGuestAccess
